//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { privacyDescList } from './privacyDescList';
import {
  getprivacysetting,
  setprivacysetting,
  uploadprivacyextfile,
} from '@/api/miniProgramManagement.js';
import { CosMixin } from '@/mixins/cos';

const patt = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
export default {
  mixins: [CosMixin],
  data() {
    return {
      appid: '',
      // 处理的信息
      privacy_desc_list: [],
      setting_list: [],
      checkList: [],
      dialogVisible: false,
      custom: {
        privacy_key: '自定义',
        privacy_text: '',
        privacy_label: '',
      },
      // 权益
      interests: [],
      email: '',
      owner_setting: {
        contact_email: '', // 信息收集方（开发者）的邮箱地址，4种联系方式至少要填一种
        contact_phone: '', // 信息收集方（开发者）的手机号，4种联系方式至少要填一种
        contact_qq: '', // 信息收集方（开发者）的qq号，4种联系方式至少要填一种
        contact_weixin: '', // 信息收集方（开发者）的微信号，4种联系方式至少要填一种
      },
      ext_file_media_id: '',
      notice_method: '',
      store_expire_timestamp: '',
      // 开发者对信息的存储
      storage: 1,
      // 补充文档
      fileList: [],
      // 协议
      protocol: false,
    };
  },
  computed: {
    getKeys() {
      // 接口返回列表处理
      return this.privacy_desc_list
        .map((item) => {
          return this.getKeyInfo[item.privacy_key];
        })
        .filter(Boolean);
      // 前端写死处理信息列表
      // return privacyDescList
    },
    getKeyInfo() {
      const obj = {};
      privacyDescList.forEach((item) => {
        obj[item.privacy_key] = item;
      });
      return obj;
    },
    keyList() {
      const arr = [];
      privacyDescList.forEach((item) => {
        arr.push(item.privacy_key);
      });
      return arr;
    },
    getEmail: {
      get() {
        return this.email || this.owner_setting.contact_email;
      },
      set(val) {
        if (patt.test(val)) {
          this.owner_setting.contact_email = val;
        } else {
          this.owner_setting.contact_email = '';
        }
        this.email = val;
      },
    },
  },
  created() {
    const { appid } = this.$route.query;
    this.appid = appid;
    // 获取设置
    this.getprivacysetting(appid);
  },
  methods: {
    goBack() {
      this.$router.history.go(-1);
    },
    async getprivacysetting(appid) {
      try {
        const data = await getprivacysetting({
          appid,
          path: '/cgi-bin/component/getprivacysetting',
          body: JSON.stringify({
            privacy_ver: 2,
          }),
        });
        const res = JSON.parse(data?.body || '{}');
        // privacy_desc_list
        this.privacy_desc_list = res?.privacy_desc?.privacy_desc_list || [];
        // setting_list
        this.setting_list = (res?.setting_list || []).map((item) => {
          if (!this.keyList.includes(item.privacy_key)) {
            // 自定义
            return {
              ...item,
              privacy_label: item.privacy_key,
              privacy_key: '自定义',
            };
          }
          return {
            ...this.getKeyInfo[item.privacy_key],
            privacy_text: item.privacy_text,
          };
        });
        // owner_setting
        this.owner_setting = res.owner_setting;
        Object.keys(res.owner_setting).forEach((key) => {
          if (['store_expire_timestamp', 'notice_method', 'ext_file_media_id'].includes(key)) {
            this[key] = res.owner_setting[key];
            if (key === 'store_expire_timestamp') {
              if (res.owner_setting[key]) {
                this.storage = 1;
              } else {
                this.storage = 2;
              }
            }
          } else {
            this.owner_setting[key] = res.owner_setting[key];
            if (res.owner_setting[key]) {
              this.interests = [...this.interests, key];
            }
          }
        });
      } catch (err) {
        console.log('err:', err);
        this.$message.error({
          message: err.errmsg,
        });
      }
    },
    // 删除收取信息
    del(number) {
      this.setting_list = this.setting_list.filter((item, index) => {
        return number !== index;
      });
    },
    // 弹窗
    openDialog() {
      // 获取选中值
      const settingkeys = this.setting_list.map((item) => {
        if (this.keyList.includes(item.privacy_key)) {
          return item.privacy_key;
        }
        return '自定义';
      });
      this.checkList = [...new Set(settingkeys)];
      // 打开弹窗
      this.dialogVisible = true;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    addSetting() {
      const userChecked = this.setting_list.map((item) => {
        return item.privacy_key;
      });
      const addArr = [];
      this.checkList.forEach((item) => {
        if (item !== '自定义') {
          if (!userChecked.includes(item)) {
            // 不包含的
            addArr.push({
              ...this.getKeyInfo[item],
              privacy_text: '',
            });
          }
        } else {
          addArr.push(JSON.parse(JSON.stringify(this.custom)));
        }
      });
      this.setting_list = [...this.setting_list, ...addArr];
      //   this.checkList = [];
      this.dialogVisible = false;
    },
    // 补充协议 TODO
    async onUploadChange(e) {
      console.log('e:', e);
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = e.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      // 截取文件类型
      const lastPointIndex = rs.lastIndexOf('.');
      const suffix = rs.substring(lastPointIndex);
      const cosParams = {
        imgCosKey: `${e.file.uid}${rs}`,
        fileObject: e.file,
        suffix,
      };
      try {
        const res = await this.putCosObject(cosParams);
        if (res?.data) {
          const { ext_file_media_id } = await uploadprivacyextfile({
            appid: this.appid,
            file_url: res.data,
            file_name: e.file.name,
          });
          this.ext_file_media_id = ext_file_media_id;
        }
      } catch (err) {
        console.log('err:', err);
        this.$message.error({
          message: err.errmsg,
        });
      }
    },
    handleRemove(file, fileList) {
      // 文件列表移除文件时的钩子
      console.log(file, fileList);
    },
    handlePreview(file) {
      // 点击文件列表中已上传的文件时的钩子
      console.log(file);
    },
    // 提交隐私指引
    async submit() {
      // 数据验证
      if (!this.setting_list.length) {
        this.$message.error('请完善【第1条】开发者处理的信息的说明');
        return;
      }
      if (
        Object.keys(this.setting_list).some((key) => {
          const text = this.setting_list[key].privacy_text;
          const label = this.setting_list[key].privacy_label;
          if (this.setting_list[key].privacy_key !== '自定义') {
            return text === '';
          }
          return text === '' || label === '';
        })
      ) {
        this.$message.error('请完善【第1条】开发者处理的信息的说明');
        return;
      }
      if (
        Object.keys(this.owner_setting).every((key) => {
          return this.owner_setting[key] === '';
        })
      ) {
        this.$message.error('请在【第2条】完善联系方式');
        return;
      }
      if (this.interests.length === 0) {
        this.$message.error('请在【第2条】完善联系方式');
        return;
      }
      if (
        this.interests.some((item) => {
          return this.owner_setting[item] === '';
        })
      ) {
        this.$message.error('请在【第2条】完善联系方式');
        return;
      }
      if (this.storage === 1 && !this.store_expire_timestamp) {
        this.$message.error('请在【第3条】完善固定存储期限');
        return;
      }
      if (!this.notice_method) {
        this.$message.error('请在【第4条】完善通知方式');
        return;
      }
      const req = {
        // privacy_ver: 2,
        owner_setting: {
          notice_method: this.notice_method,
        },
        setting_list: this.setting_list.map((item) => {
          if (!this.keyList.includes(item.privacy_key)) {
            // 自定义
            return {
              privacy_key: 'user_key',
              privacy_text: item.privacy_text,
              privacy_desc: item.privacy_label,
              privacy_label: item.privacy_label,
            };
          }
          return {
            privacy_key: item.privacy_key,
            privacy_text: item.privacy_text,
            // privacy_label: item.privacyDesc || item.privacy_label,
          };
        }),
      };
      this.interests.forEach((key) => {
        if (this.owner_setting[key]) {
          req.owner_setting[key] = this.owner_setting[key];
        }
      });
      if (this.ext_file_media_id) {
        req.owner_setting.ext_file_media_id = this.ext_file_media_id;
      }
      if (this.store_expire_timestamp) {
        req.owner_setting.store_expire_timestamp = this.store_expire_timestamp;
      }
      // 提交数据
      try {
        const res = await setprivacysetting({
          appid: this.appid,
          path: '/cgi-bin/component/setprivacysetting',
          body: JSON.stringify({
            ...req,
          }),
        });
        console.log(res);
        this.$message({
          message: '设置成功',
          type: 'success',
        });
        this.goBack();
      } catch (err) {
        console.log('err:', err);
        this.$message.error({
          message: err.errmsg,
        });
      }
    },
  },
};
